import React from "react";
import InputToggleable, { InputToggleableObject } from "../InputToggleable";

export interface InputRadioProps extends InputToggleableObject {}

export default function InputRadio(props: InputRadioProps) {
  return <InputToggleable {...props} type="radio" />;
}
